// src/components/SearchableSelect.js
// Generic searchable dropdown for large option lists (employees, students, buses...).
import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

const SearchableSelect = ({
  label,
  options, // [{ id, label }]
  value, // id of the selected option
  onChange, // (id) => void
  required,
  fullWidth = true,
  disabled,
  sx,
  noOptionsText = 'لا توجد نتائج',
  ...rest
}) => {
  const selected = options?.find((opt) => opt.id === value) || null;

  return (
    <Autocomplete
      options={options || []}
      value={selected}
      disabled={disabled}
      getOptionLabel={(option) => option?.label || ''}
      isOptionEqualToValue={(option, val) => option.id === val.id}
      noOptionsText={noOptionsText}
      onChange={(event, newValue) => onChange(newValue?.id ?? '')}
      fullWidth={fullWidth}
      renderInput={(params) => (
        <TextField {...params} label={label} required={required} sx={sx} />
      )}
      {...rest}
    />
  );
};

export default SearchableSelect;
